import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"
import { AlertTriangle } from "lucide-react"

interface WorkflowConfirmationDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    onConfirm: () => void
    title?: string
    description?: string
    confirmText?: string
    cancelText?: string
    isSubmitting?: boolean
    variant?: "danger" | "warning"
}

export function WorkflowConfirmationDialog({
    open,
    onOpenChange,
    onConfirm,
    title = "Are you sure?",
    description = "This action cannot be undone.",
    confirmText = "Confirm",
    cancelText = "Cancel",
    isSubmitting = false,
    variant = "danger",
}: WorkflowConfirmationDialogProps) {
    const isDanger = variant === "danger"

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px] bg-card">
                <DialogHeader>
                    <div className="flex items-center gap-3">
                        <div className={`p-2 rounded-full ${isDanger ? 'bg-destructive/10' : 'bg-amber-400/10'}`}>
                            <AlertTriangle className={`w-5 h-5 ${isDanger ? 'text-destructive' : 'text-amber-600'}`} />
                        </div>
                        <DialogTitle>{title}</DialogTitle>
                    </div>
                    <DialogDescription className="text-muted-foreground mt-3 pl-11">
                        {description}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="mt-6 gap-2">
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isSubmitting}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={isDanger ? "destructive" : "default"}
                        onClick={onConfirm}
                        disabled={isSubmitting}
                        className={isDanger ? "" : "bg-amber-600 hover:bg-amber-600/90"}
                    >
                        {isSubmitting ? "Processing..." : confirmText}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
